// Static config served from S3 + CloudFront (no auth, public CDN). Override
// in dev with `VITE_APP_VERSION_URL` to point at a local mock if needed.
export const APP_VERSION_URL =
  import.meta.env.VITE_APP_VERSION_URL ??
  "https://assets.allaria.cloud/native/app-version.json";

// Tight enough to avoid blocking cold-start UX, generous enough for slow
// 3G. Mirrors FIRST_RUN_GET_LATEST_TIMEOUT_MS in useOtaUpdates.ts.
export const APP_VERSION_FETCH_TIMEOUT_MS = 5000;

// Re-check after foregrounding only if the app was in background for at
// least this long. Quick foreground/background cycles (notification
// checks, app switches) don't trigger a fresh fetch. Resume mid-operation
// scenarios are filtered out: only a "real" return from background after
// being away for >=1 hour can surface a forced-update screen.
export const APP_VERSION_RECHECK_AFTER_MS = 60 * 60 * 1000;

// Capacitor Preferences key. Stores the last successful response with a
// timestamp so we can fall back to it if a future fetch fails.
export const APP_VERSION_CACHE_KEY = "app_version_cache";

// Toast shown when the user taps "Actualizar" but the store URLs are not
// configured yet (apps not yet published).
export const APP_VERSION_NOT_PUBLISHED_TOAST = "Actualización no disponible";

// react-toastify containerId targeted by openAppStore. Each update screen
// mounts its own <ToastMessage> with this id so toasts are visible while
// the regular Layout (and its container) are not in the tree.
export const APP_VERSION_TOAST_CONTAINER_ID = "appVersionGate";
